import banner from "../assets/img/banner.png";
import banner_mobile from "../assets/img/banner_mobile.png";
import useScrollAnimation from "../hooks/useScrollAnimation";

const ShinyHeffers = () => {
  const textRef = useScrollAnimation();

  return (
    <div className="py-[50px] bg-black/10 shiny-heffers-bg relative overflow-hidden">
      {/* Decorative glow orbs */}
      <div className="absolute top-20 left-[-100px] w-[300px] h-[300px] bg-[#E71CA5] opacity-[0.07] rounded-full blur-[100px] animate-float" />
      <div className="absolute bottom-10 right-[-80px] w-[250px] h-[250px] bg-[#15D9E8] opacity-[0.07] rounded-full blur-[100px] animate-float" style={{ animationDelay: "3s" }} />

      <div className="container mx-auto px-[1.8%]">
        <div className="mb-8 animate-fade-in">
          <img
            src={banner}
            alt="Shiny Heffers Banner"
            className="w-840 h-302 hidden md:block drop-shadow-2xl animate-float"
          />
          <img
            src={banner_mobile}
            alt="Shiny Heffers Banner"
            className="md:hidden w-full mx-auto drop-shadow-xl animate-float"
          />
        </div>
      </div>
      <div className="container mx-auto px-[6%]">
        <div ref={textRef} className="animate-on-scroll">
          <div className="content-box p-8 md:p-12 max-w-3xl mx-auto text-center">
            <h3 className="text-[26px] md:text-[47px] font-bold font-Poppins text-white">
              <span className="gradient-text">Mission Statement</span>
            </h3>
            <p className="text-[15px] xl:text-[17px] font-Poppins text-white/80 leading-8 mt-4">
              Shiny Heffers ($SHIT) is a meme coin with purpose, created to
              drive visibility and funding for decentralized vertical farming
              and regenerative beef production. Through the fusion of agri-tech
              innovation and blockchain tokenization, we create a sustainable
              pathway to food security, nutritional excellence, and investor
              wealth — operating cross-chain on{" "}
              <span className="font-bold text-[#E71CA5]">Binance Smart Chain</span> and{" "}
              <span className="font-bold text-[#15D9E8]">KleverChain</span>.
            </p>
            <p className="text-[16px] xl:text-[18px] font-Poppins text-white leading-10 mt-4 font-bold">
              Are you ready for this SHIT?
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShinyHeffers;
